import { createSelector } from "reselect";

import { createGetBetsByParams } from "src/selectors";

export const createGetBets = (gameId: number) =>
  createSelector([createGetBetsByParams([gameId], [], [])], (bets) =>
    bets.filter((bet) => bet.win)
  );
